import { convertCurrency, toLocaleString } from "./modules/convertCurrency";
export default {
	convertCurrency,
	toLocaleString, //千分位
};
